import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO } from "../../data/seo";
import { restaurant } from "../../data/siteData";

const setAttr = (selector, attr, value) => {
  document.head.querySelector(selector)?.setAttribute(attr, value);
};

export const Seo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = SEO[pathname] ? pathname : "/";
    const { title, description } = SEO[path];
    const url = `${restaurant.siteUrl}${path === "/" ? "/" : path}`;
    document.title = title;
    setAttr('meta[name="description"]', "content", description);
    setAttr('link[rel="canonical"]', "href", url);
    setAttr('meta[property="og:title"]', "content", title);
    setAttr('meta[property="og:description"]', "content", description);
    setAttr('meta[property="og:url"]', "content", url);
    setAttr('meta[name="twitter:title"]', "content", title);
    setAttr('meta[name="twitter:description"]', "content", description);
  }, [pathname]);
  return null;
};
